import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { EntityContext } from '../../entity';
import Loading from '../loading';

export default function DashboardIndexRedirect() {
  const { entity, entityHasActivePlan, entityPlanStatusLoading } = useContext(EntityContext);

  const hasValidEntity = entity && typeof entity === 'object' && entity.api_key;

  if (!hasValidEntity) {
    return <Navigate to="/dashboard/entities" replace />;
  }

  if (entityPlanStatusLoading) {
    return <Loading />;
  }

  if (entityHasActivePlan === false) {
    return <Navigate to="/dashboard/pendingSignatures" replace />;
  }

  if (entityHasActivePlan === true) {
    return <Navigate to="/dashboard/app" replace />;
  }

  return <Navigate to="/dashboard/pendingSignatures" replace />;
}
